import {FanduelReoptimizedLineupsView} from './fanduel-reoptimized-lineups-view';
import {DraftkingsReoptimizedLineupsView} from './draftkings-reoptimized-lineups-view';
import {YahooReoptimizedLineupsView} from './yahoo-reoptimized-lineups-view';
import ReoptimizedLineupsViewInterface from './reoptimized-lineups-view-interface';
import ReoptimizedLineupsViewNotFoundError from './reoptimized-lineups-view-not-found-error';

const viewMap = {
    draftkings: DraftkingsReoptimizedLineupsView,
    fanduel: FanduelReoptimizedLineupsView,
    yahoo: YahooReoptimizedLineupsView,
};

const ReoptimizedLineupsViewFactory = {
    getView(sportConfig): ReoptimizedLineupsViewInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return new viewMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new ReoptimizedLineupsViewNotFoundError('Reoptimized Lineups View is undefined');
            }
            throw e;
        }
    },
};

export default ReoptimizedLineupsViewFactory;
